// @ts-nocheck
export const styles = (theme) => ({
    root: {
        margin: 0,
        padding: "16px",
    },
    closeButton: {
        position: 'absolute',
        right: "8px",
        top: "8px",
        color: theme.palette.grey[500],
    },
});